import { useDeveloperStore } from '@stores';
import {
  Logo,
  Identifier,
  IdentifierMasthead,
  IdentifierLogo,
  IdentifierIdentity,
  IdentifierLinks,
  IdentifierLinkItem,
  IdentifierGov,
} from '@trussworks/react-uswds';
import ProgressiveImage from '@components/progressive-image/ProgressiveImage';
import ExternalLink from '@components/external-link/ExternalLink';

import './footer.scss';

const links = [
  { content: 'Accessibility support', href: 'https://dodcio.defense.gov/DoDSection508/Std_Stmt.aspx' },
  { content: 'Contact Us', href: 'https://www.usace.army.mil/Resources/Contact/' },
  { content: 'Quality Act', href: 'https://www.usace.army.mil/Information-Quality-Act/' },
  { content: 'Link Disclaimer', href: 'https://www.usace.army.mil/Link-Disclaimer/' },
  { content: 'Privacy & Security', href: 'https://www.usace.army.mil/Privacy-and-Security/' },
  { content: 'No Fear Act', href: 'https://prhome.defense.gov/nofear' },
  { content: 'EEO & SHARP', href: 'https://www.usace.army.mil/Careers/EEO/' },
  { content: 'Small Business', href: 'https://www.usace.army.mil/Business-With-Us/Small-Business/' },
  { content: 'Open Government', href: 'https://open.defense.gov/' },
  {
    content: 'Office of the Inspector General',
    href: 'https://www.usace.army.mil/About/Offices-and-Units/Engineer-Inspector-General/',
  },
  { content: 'FOIA requests', href: 'https://www.usace.army.mil/Resources/FOIA' },
  { content: 'iSALUTE', href: 'https://www.usainscom.army.mil/isalute/' },
  { content: 'Veterans Crisis Line', href: 'https://www.veteranscrisisline.net/get-help-now/military-crisis-line/' },
];

const linkList = links.map((link) => (
  <IdentifierLinkItem key={link.content}>
    <ExternalLink className='footer-link' content={link.content} href={link.href} />
  </IdentifierLinkItem>
));

const identifierGovContent = (
  <>
    Looking for U.S. government information and services?{' '}
    <ExternalLink content='Visit USA.gov' href='https://usa.gov' />
  </>
);

const RRSFooter = () => {
  const { bannerInfo } = useDeveloperStore();
  const { version } = bannerInfo;
  return (
    <Identifier className='footer-container'>
      <IdentifierMasthead aria-label='Agency identifier'>
        <IdentifierLogo href='https://www.army.mil'>
          <Logo
            size='small'
            image={
              <ProgressiveImage
                className='army-star-logo'
                alt='U.S. Army'
                localPath='site-graphics/armystar-logo-rb.svg'
                height={50}
              />
            }
          />
        </IdentifierLogo>
        <IdentifierLogo href='https://www.usace.army.mil'>
          <Logo
            size='small'
            image={
              <ProgressiveImage
                className='usace-logo'
                alt='USACE Logo'
                localPath='site-graphics/usace-logo-color.svg'
                height={50}
              />
            }
          />
        </IdentifierLogo>
        <IdentifierIdentity domain='rrs.usace.army.mil' className='margin-left-105'>
          <span aria-hidden='true'>An</span>
          {' official website of the '}
          <ExternalLink href='https://www.army.mil' content='United States Army' />
          {' and the '}
          <ExternalLink href='https://www.usace.army.mil' content='U.S. Army Corps of Engineers' />
        </IdentifierIdentity>
      </IdentifierMasthead>
      <IdentifierLinks
        navProps={{
          'aria-label': 'Important links',
        }}
      >
        {linkList}
      </IdentifierLinks>
      <IdentifierGov aria-label='U.S. government information and services'>{identifierGovContent}</IdentifierGov>
      <IdentifierGov aria-label='Civil Works Business Intelligence'>
        <div className='display-flex flex-align-center'>
          <Logo
            size='small'
            image={
              <ProgressiveImage
                className='cwbi-logo'
                alt='CWBI Logo'
                localPath='site-graphics/CWBI_Logo-Small.png'
                height={50}
                hasAvif
                hasWebp
              />
            }
          />
          <span className='margin-left-1'>Powered by Civil Works Business Intelligence (CWBI)</span>
          <span className='margin-left-auto' title='Version'>
            RRS v{version}
          </span>
        </div>
      </IdentifierGov>
    </Identifier>
  );
};

export default RRSFooter;
